import { EntityLayout } from '@backstage/plugin-catalog';
import { EntityLayoutWrapper } from './common/EntityLayoutWrapper';
import { ComponentOverviewContent } from './common/ComponentOverviewContent';
import {
  EntityDeploymentsContent,
  isDeploymentsAvailable,
} from '@appfolio/backstage-plugin-deployments';
import {
  EntityCodeOwnershipContent,
  isCodeOwnershipEnabled,
} from '@appfolio/backstage-plugin-code-ownership';

export const componentEntity = (
  <EntityLayoutWrapper>
    <EntityLayout.Route path="/" title="Overview">
      <ComponentOverviewContent />
    </EntityLayout.Route>
    <EntityLayout.Route
      path="/deployments"
      title="Deployments"
      if={isDeploymentsAvailable}
    >
      <EntityDeploymentsContent />
    </EntityLayout.Route>
    <EntityLayout.Route
      path="/ownership"
      title="Code Ownership"
      if={isCodeOwnershipEnabled}
    >
      <EntityCodeOwnershipContent />
    </EntityLayout.Route>
  </EntityLayoutWrapper>
);
